import * as React from 'react';
import { StyledNavigationItemLink } from '../Navigation/NavigationItem.Styled';
import { INavigationItemProps } from '../Navigation';

interface IOpenLinkInNewTab extends INavigationItemProps {
  onClick: () => void;
  href: string;
}

export const OpenLinkInNewTab: React.FunctionComponent<IOpenLinkInNewTab> = (props) => {
  return (
    <StyledNavigationItemLink
      {...props}
      rel="noopener noreferrer"
      target="_blank"
      onClick={props.onClick}
      href={props.href}
      data-test-id={`link-${props.text || props.href}`}
      data-test-class={'link'}
    >
      {props.text || props.children}
    </StyledNavigationItemLink>
  );
};
